export default __webpack_public_path__ + "static/media/roadmap-d-2.a84fd83f.png";